import { render, staticRenderFns } from "./questionPreview.vue?vue&type=template&id=1d08350f&scoped=true&"
import script from "./questionPreview.vue?vue&type=script&lang=ts&"
export * from "./questionPreview.vue?vue&type=script&lang=ts&"
import style0 from "./questionPreview.vue?vue&type=style&index=0&id=1d08350f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08350f",
  null
  
)

export default component.exports